import type { Risk } from "@/lib/types";

export const RISKS: Risk[] = [
  {
    id: 1,
    title: "Pricing is the longest pole",
    severity: "high",
    owner: "Stephen",
    detail: "Must conclude by May 15. Blocks pricing page, ROI calc, sequences, expansion playbook. Requires: cost estimate from Product/Eng, customer calls, internal alignment.",
    status: "open",
  },
  {
    id: 2,
    title: "Twilio approval lead time",
    severity: "high",
    owner: "Ryan / Tom",
    detail: "Beta accounts need Twilio approved by May 4. Takes 2+ weeks. Ryan must include Twilio instructions in beta invitations immediately.",
    status: "open",
  },
  {
    id: 3,
    title: "CS capacity depends on A/B test",
    severity: "medium",
    owner: "Courtney / Dustin",
    detail: "Open Beta targets 20 accts/week. If high-touch wins A/B, need headcount. If self-serve wins, product must confirm Felix handles it. Decision at Jun 2 gate.",
    status: "open",
  },
  {
    id: 4,
    title: "EB launch (Apr 15) will tax resources",
    severity: "medium",
    owner: "Stephen",
    detail: "Email Builder launches same week as Alpha+. Teams will be stretched. Monitor for bottlenecks.",
    status: "open",
  },
  {
    id: 5,
    title: "Website pricing page blocked by pricing",
    severity: "low",
    owner: "Seth / Stephen",
    detail: "Cannot publish pricing page until framework is locked (May 15). If pricing slips, GA website is incomplete.",
    status: "open",
  },
];
